import React from "react";
import Modal from "../Modal/Modal";

export default function ProductReviewModal({
  isOpen,
  onClose,
  isMobile = false,
  selectedReviewItem = null,
  reviewFormData = { rating: 0, review_text: "" },
  onRatingChange,
  onTextChange,
  onSubmit,
  isSubmitting = false,
}) {
  return (
    <Modal onClose={onClose} isOpen={isOpen} maxWidth="520px">
      <div
        className={`review-modal-container ${isMobile ? "mobile-review-modal" : ""}`}
      >
        <h3 className="review-modal-title">Add Review</h3>

        {selectedReviewItem ? (
          <div className="review-product-summary">
            <div className="review-product-name">
              {selectedReviewItem.product_name}
            </div>
            <div className="review-product-order">
              Order #{selectedReviewItem.order_number}
            </div>
          </div>
        ) : null}

        <div className="review-form-group">
          <label className="review-form-label required">Rating</label>
          <div className="review-stars-row" role="radiogroup" aria-label="Rating">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                className={`review-star-btn ${reviewFormData.rating >= star ? "selected" : ""}`}
                onClick={() => onRatingChange(star)}
                aria-label={`${star} star${star > 1 ? "s" : ""}`}
              >
                ★
              </button>
            ))}
          </div>
        </div>

        <div className="review-form-group">
          <label className="review-form-label required">Description</label>
          <textarea
            className="review-textarea"
            rows="5"
            maxLength="1000"
            placeholder="Write your review"
            value={reviewFormData.review_text}
            onChange={onTextChange}
          />
          <div className="review-character-count">
            {String(reviewFormData.review_text || "").length}/1000
          </div>
        </div>

        <div className="review-modal-actions">
          <button
            type="button"
            className="address-btn-secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="address-btn-primary"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Review"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
